import { Component, computed, effect, input, output, signal, untracked } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerChevronDown } from '@ng-icons/tabler-icons';
import { DotMatrixLoader } from '../dot-matrix-loader/dot-matrix-loader';
import { ReasoningTask, ReasoningTaskList } from './reasoning-task-list';

let nextId = 0;

@Component({
  selector: 'reasoning-loader',
  templateUrl: './reasoning-loader.html',
  styleUrl: './reasoning-loader.scss',
  imports: [NgTemplateOutlet, NgIcon, DotMatrixLoader, ReasoningTaskList],
  providers: [provideIcons({ tablerChevronDown })],
  host: {
    '[class.active]': 'active()',
  },
})
export class ReasoningLoader {
  readonly label = input.required<string>();
  readonly active = input(false);
  readonly thoughts = input<string[]>([]);
  readonly tasks = input<ReasoningTask[]>([]);
  readonly expanded = input(false);
  readonly expandedChange = output<boolean>();

  readonly bodyId = `reasoning-loader-body-${nextId++}`;
  readonly hasBody = computed(() => this.thoughts().length > 0 || this.tasks().length > 0);

  private readonly startedAt = signal<number | null>(null);
  private readonly now = signal(Date.now());
  readonly elapsedSeconds = computed(() => {
    const startedAt = this.startedAt();
    return startedAt === null ? null : Math.max(0, Math.floor((this.now() - startedAt) / 1000));
  });

  constructor() {
    effect((onCleanup) => {
      if (!this.active()) {
        this.now.set(Date.now());
        return;
      }
      if (untracked(this.startedAt) === null) {
        this.startedAt.set(Date.now());
      }
      this.now.set(Date.now());
      const timer = setInterval(() => this.now.set(Date.now()), 1000);
      onCleanup(() => clearInterval(timer));
    });
  }

  toggle() {
    this.expandedChange.emit(!this.expanded());
  }
}
